import { useParams } from "react-router-dom";
import { PageHeader } from "../../../commons/component/PageHeader/PageHeader";
import { Label, Pivot, PivotItem, Separator, IPivotItemProps } from "@fluentui/react";
import { Badge } from '@fluentui/react-components';

// components
import ProtocolHeaderComponent from "../../../components/Protocols/ProtocolHeader/ProtocolHeader.Component";
import ProtocolContractComponent from "../../../components/Protocols/ProtocolContract/ProtocolContract.Information/ProtocolContract.Component";
import ConsumtionListComponent from "../../../components/Protocols/ConsumptionList/ConsumptionList.Component";
import ProtocolTotalsComponent from "../../../components/Protocols/ConsumptionsByStatus/ConsumptionTotals.Component";

// styles
import './ProtocolDetails.Styles.css';
import SettlementListComponent from "../../../components/Settlements/SettlementList/SettlementList.Component";
import PaymentAccountDetailsComponent from "../../../components/PaymentAccount/PaymentAccountDetails/PaymentAccountDetails.Component";

////i18Next
import { useTranslation, Trans } from 'react-i18next';
import ConceptListComponent from "../../../components/Contracts/Concept/ConceptList/ConceptList.Component";
import ProtocolActivityComponent from "../../../components/Protocols/ProtocolActivity/Protocol.Activity.Component";
import ConsumptionVisitListComponent from "../../../components/Protocols/ConsumptionVisitList/ConsumptionVisit.List.Component";
import ConsumptionToSettleComponent from "../../../components/Protocols/ConsumptionToSettle/ConsumptionToSettle.Component";
import ConsumptionSyncProcessComponent from "../../../components/Protocols/ConsumptionSyncProcess/ConsumptionSyncProcess.Component";
import ProyectionComponent from "../../../components/Protocols/Proyection/Proyection.component";
import { New24Regular } from "@fluentui/react-icons";
import { IConsumptionsFilters } from "../../../models/Filters/ConsumptionsFilters";
import { useState } from "react";
import ProtocolContractTabComponent from "../../../components/Protocols/ProtocolContract/ProtocolContract.Tab/ProtocolContract.Component";
import { ContractStatistics } from "../../../components/Contracts/statistics/ContractStatistics.Component";

export const ProtocolDetailPage = () => {
    const { ProtocolId } = useParams();
    const [filters, setFilters] = useState<IConsumptionsFilters>({
        SelectedConsumptions: [],
        SelectedProtocolPatients: [],
        SelectedContractConcepts: [],
        SelectedCurrencys: '',
        SelectedContractStages: [],
        SelectedPractitioners: [],
        SelectedStatus: [],
        SelectedProtocols: [],
        SelectedSettlements: [],
        SelectedDateRange: [undefined, undefined],
        FilterText: undefined,
        showGroupedByVisit: false,
        GroupId: undefined,
    });

    //useTranslation
    const [t] = useTranslation()

    // Ejemplo: valores de badges (reemplazar con datos reales)
    const activityCount = undefined; // e.g. número de eventos
    const consumptionsCount = undefined; // e.g. número de consumos
    const settlementsCount = undefined; // e.g. número de liquidaciones
    const projectionCount = undefined; // e.g. algún indicador de proyección (p.ej. meses proyectados)

    const onRender = () => {
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <span>{t('protocolDetailsPage.protocolDetailsTitle')}</span>
                <Badge appearance="filled" size="medium" color="brand">
                    {" Beta "}
                </Badge>
            </div>
        );
    };

    return (
        <>
            <PageHeader title={t('protocolDetailsPage.protocolDetailsTitle')} />
            <div className="protocolHeader-stickyWrap">
                <ProtocolHeaderComponent ProtocolId={Number(ProtocolId)} />
            </div>
            <ProtocolContractTabComponent ProtocolId={Number(ProtocolId)} />
            <div className="Section Tabed">
                
                <Pivot>
                    <PivotItem itemKey="activity" headerText={t('protocolDetailsPage.protocolDetailsItem.activity')}>
                        <ProtocolActivityComponent ProtocolId={Number(ProtocolId)} />
                    </PivotItem>
                    <PivotItem itemKey="consumptions" headerText={t('protocolDetailsPage.protocolDetailsItem.consumptions')}>
                        <div className="detailsTotalsContainers">
                            <ProtocolTotalsComponent ProtocolId={Number(ProtocolId)} status={0} />
                            <ProtocolTotalsComponent ProtocolId={Number(ProtocolId)} status={1} />
                            <ProtocolTotalsComponent ProtocolId={Number(ProtocolId)} status={3} />
                            <ProtocolTotalsComponent ProtocolId={Number(ProtocolId)} status={2} />
                            <ProtocolTotalsComponent ProtocolId={Number(ProtocolId)} status={6} />
                            <ProtocolTotalsComponent ProtocolId={Number(ProtocolId)} status={5} />
                        </div>
                        {ProtocolId && <ConsumptionSyncProcessComponent ProtocolId={Number(ProtocolId)} filters={filters} />}
                        {ProtocolId && <ConsumptionToSettleComponent ProtocolId={Number(ProtocolId)} status={6} />}
                        <ConsumtionListComponent onChangeFilters={(newFilter: IConsumptionsFilters) => setFilters(newFilter)} ProtocolId={Number(ProtocolId)} StageId={undefined} PatientNumberInProtocol={undefined} ProducerId={undefined} ProviderId={undefined}  />
                    </PivotItem>
                    <PivotItem itemKey="contract" headerText={t('protocolDetailsPage.protocolDetailsItem.contract')}>
                        <div className="VisitasSection">
                            <div>
                                <SettlementListComponent ProtocolId={Number(ProtocolId)} />
                            </div>
                            <div>
                                <ProtocolContractComponent ProtocolId={Number(ProtocolId)} />
                            </div>
                        </div>
                    </PivotItem>
                    {/* <PivotItem headerText={t('protocolDetailsPage.protocolDetailsItem.accountStatus')}>
                    <PaymentAccountDetailsComponent />
                </PivotItem> */}
                    {/* <PivotItem headerText="Conceptos a liquidar">
                    <ConceptListComponent 
                        ContractId={Number(ContractId)}
                    />
                </PivotItem> */}
                    <PivotItem itemKey="statistics" headerText={t('protocolDetailsPage.protocolDetailsItem.statistics', 'Estadísticas')}>
                        <ContractStatistics ProtocolId={Number(ProtocolId)} />
                    </PivotItem>
                    {process.env.REACT_APP_PREVIEW_FEATURES === 'true' && <PivotItem itemKey="projection" headerText={"Proyección"} onRenderItemLink={onRender}>
                        <ProyectionComponent protocolId={Number(ProtocolId)} />
                    </PivotItem>}
                </Pivot>
            </div>
        </>);
}